export default __webpack_public_path__ + "static/media/roller.bb3232e5.svg";